// extracted by mini-css-extract-plugin
export var content = "breadCrumbs-module--content--3a842";
export var link = "breadCrumbs-module--link--0f872";
export var list = "breadCrumbs-module--list--a1fb9";
export var listItem = "breadCrumbs-module--listItem--c64a5";
export var wrapper = "breadCrumbs-module--wrapper--d56bc";